// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"d9b9010279971a525488","883":"feb856e960afb4b7ca8e"}[chunkId] + ".js";
};